import { AddCommentModalComponent } from './../../../shared/components/modals/add-comment/add-comment-modal.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BcComponentsService, DetailBcinfos } from '../bc-components.service';
import { BcValidationModel } from 'src/app/shared/dtos/bcValidationModel';
import { ToastrService } from 'ngx-toastr';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { CycleBcModel } from 'src/app/shared/models/societe-linked/bc/cycle-bc.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { ModalCycleValidationComponent } from '../modals/modal-cycle-validation/modal-cycle-validation.component';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { NTHFlag } from 'src/app/shared/constants/flag';

@Component({
  selector: 'app-validate-bc',
  templateUrl: './validate-bc.component.html',
  styleUrls: ['./validate-bc.component.scss']
})
export class ValidateBcComponent implements OnInit, OnDestroy  {
  bcForm: UntypedFormGroup;
  observableBc = new BehaviorSubject<BcModel>(null);
  bc: BcModel = new BcModel();
  idBc: number;
  detailBcInfo: DetailBcinfos;
  bcLineHTs = 0;
  bcLineTVAs = 0;
  bcLineTTCs = 0;
  childHeight: number = 0;
  parentWidth: number = 0;
  

  constructor(private bcService: BcService,
              protected toastr: ToastrService,
              private router: Router,
              private dialog: MatDialog,
              private bcComponentsService: BcComponentsService,
              private route: ActivatedRoute,
              private title: Title,
              private toastrService: ToastrService,
              private societeService: SocieteService) {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.bcService.bcSubscriber.subscribe((bc: BcModel) => {
          if (bc !== null) {
            this.bc = Object.assign({}, bc);
          } else {
            this.toastrService.error('Erreur durant la récupération du bon de commande.', 'Erreur');
            this.router.navigate(['/']);
          }
        });
      } else {
        this.bcService.get(params.id).subscribe(bc => {
          this.bc = bc;
          this.title.setTitle('SACHA - Validation BC');
          this.detailBcInfo = new DetailBcinfos();
          this.bcLineHTs = bc.ht;
          this.bcLineTVAs = bc.tva;
          this.bcLineTTCs = bc.ttc;
          this.bcForm = this.bcComponentsService.getValidateBcFormGroup(this.bc);
          this.societeService.get(this.bc.idSociete).subscribe((res) => this.bc.societe = res);
          this.observableBc.next(this.bc);
        }, (error) => {
          toastrService.error('Le bon de commade n\'existe pas');
          this.router.navigate(['/not-found']);
        });
      }

    });
  }

  ngOnInit(): void {
    this.verifyBcStatusToRedirect();
    this.getChildHeight();
    this.getParentWidth();  
  }

  ngOnDestroy(): void {
    this.bcComponentsService.purgeDetailBcInfo();
  }

  verifyBcStatusToRedirect(): void {
    if (this.observableBc) {
      this.observableBc.subscribe((bc: BcModel) => {
        if (bc) {
          if (bc.statusNum < 2 || bc.statusNum >= 10) {
            this.router.navigate(['/']);
            this.toastr.warning('Ce bon de commande est en brouillon ou a déjà été validé.', 'Erreur');
          }
        }
      });
    }
  }

  close(): void {
    this.router.navigate(['/list-bc/']);
  }
  refus(): void {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire de refus',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
      if (res !== '' && res) {
        const obj = new BcValidationModel(this.bc);
        obj.commentaire = res;
        this.bcComponentsService.refusBc(obj).subscribe(x => {
          this.router.navigate(['/list-bc/']);
        });
      }
      else if (res === '') {
        this.toastr.error('commentaire obligatoire');
      }

    });
  }
  validate(): void {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire de validation',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
      if (res === '' || res) {
        const obj = new BcValidationModel(this.bc);
        obj.commentaire = res;
        this.bcComponentsService.validateBc(obj).subscribe(x => {
          this.router.navigate(['/list-bc/']);
        });
      }
    });
  }

  print(): void {
    window.open('/assets/pdfs/bcpdf.pdf');
  }


  calculateTvas(object: any): void {
    if (this.getTvaAMount(object) !== undefined) {
      this.bcLineTVAs = this.getTvaAMount(object);

    }
  }

  calculateTtcs(object: any): void {
    if (this.getTtcAMount(object) !== undefined) {
      this.bcLineTTCs = this.getTtcAMount(object);
    }
  }

  getHtAMount(object: any): number {
    // tslint:disable-next-line
    let amountsHt = [];
    let amountHtTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountHtValue = 0;
      if (object[obj].amount !== undefined) {
        amountHtValue = amountHtValue + object[obj].amount;
        amountsHt.push(amountHtValue);
        if (obj === object.length - 1) {
          for (const amount of amountsHt) {
            amountHtTotal += amount;
          }
          return amountHtTotal;
        }
      }
    }
  }

  getTvaAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTva = [];
    let amountTvaTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTvaValue = 0;
      if (object[obj].amount !== undefined) {
        amountTvaValue = amountTvaValue + object[obj].amount;
        amountsTva.push(amountTvaValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTva) {
            amountTvaTotal += amount;
          }

          return amountTvaTotal;
        }
      }
    }
  }

  getTtcAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTtc = [];
    let amountTtcTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTtcValue = 0;
      if (object[obj].amount !== undefined) {
        amountTtcValue = amountTtcValue + object[obj].amount;
        amountsTtc.push(amountTtcValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTtc) {
            amountTtcTotal += amount;
          }
          return amountTtcTotal;
        }
      }
    }
  }

  bloquer() {
    this.bc.bBloque = true;
    this.bcService.update(this.bc.id, this.bc).subscribe(value => {
    });
  }

  debloquer() {
    this.bc.bBloque = false;
    this.bcService.update(this.bc.id, this.bc).subscribe(value => {
    });
  }

  getChildHeight(): any {
    setTimeout(() => {
      const childHeight = document.querySelector('#heigthChild') !== null ? document.querySelector('#heigthChild').clientHeight : null;
      if (childHeight && childHeight > 0) {
        this.childHeight = childHeight;
      }
    }, 200);
  }

  getParentWidth(): any {
    setTimeout(() => {
      // tslint:disable-next-line: max-line-length
      const parentWidth = document.querySelector('#validate-bc-container') !== null ? document.querySelector('#validate-bc-container').clientWidth : null;
      if (parentWidth && parentWidth > 0) {
        this.parentWidth = parentWidth;
      }
    }, 200);
  }

  openCycleValidation() {
    const dialog = this.dialog.open(ModalCycleValidationComponent, {
      data: {
        idBc: this.bc.id,
        idSociete: this.bc.idSociete,
        codeCa1: this.bcForm.get('codeCa1').value
      }
    });
  }
}
